import { Text } from '@change/ds-core-ui';

import type { AdvocateAvatarProps } from '../../types';

import { useAdvocateInfo } from './hooks';

export function AdvocateInfo({ hasAdvocatesState, petitionAdvocates }: AdvocateAvatarProps): JSX.Element {
	const { title, subtitle } = useAdvocateInfo({ hasAdvocatesState, petitionAdvocates });

	return (
		<div className="flex flex-col">
			<Text variant="body" size="large" fontWeight="bold" className="text-typography-strong">
				{title}
			</Text>
			<Text variant="body" className="text-typography-weak">
				{subtitle}
			</Text>
		</div>
	);
}
